export default function Section2() {
  return (
    <div className="w-full Section2">
      <div className="flex items-center justify-center w-full section2-container">
        <div className="text-center w-[90%] md:w-[70%] lg:w-[60%] mx-auto">
          <h1 className="mt-[40px] mb-[1%] md:mb-0 text-[24px] leading-[29px] md:text-[40px] font-bold md:leading-[41px] text-[#151515]">
            WordPress Development Company in Dubai and Across the UAE
          </h1>
          <p className="leading-[22px] text-[#373737] text-base font-open max-w-[700px] mx-auto mt-10">
            At Mean3, we create custom WordPress websites designed to help UAE businesses stand out online. As a leading WordPress development company in Dubai, we specialize in building high-performance, secure, bilingual and SEO-friendly websites that attract visitors and drive results. Whether you’re starting a new project, migrating from another platform, or upgrading your current site, our Dubai-based WordPress experts deliver end-to-end solutions that fit your business goals and brand vision.
          </p>
        </div>
      </div>

      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
